import { RuleObject } from "antd/lib/form"
import { Regex } from "../../../constant/Regex"
import { Translate } from "../../../constant/Translate"

const { REGEX_EMAIL } = Regex
const { MESSAGE_E0015 } = Translate

export const validatorEmailAddress = () => ({
  validator(_: RuleObject, value: string) {
    if (value && !REGEX_EMAIL.exec(value)) {
      return Promise.reject(new Error(MESSAGE_E0015))
    }
    return Promise.resolve()
  },
})
